import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./Firebase";

const functions = getFunctions(firebaseApp, "asia-south1");

async function call<TRequest, TResponse>(name: string, data: TRequest): Promise<TResponse> {
    const callable = httpsCallable<TRequest, TResponse>(functions, name);
    const result = await callable(data);
    return result.data;
}

export type EnrollmentProgram = {
    id: string;
    name: string;
    type: "INTERNSHIP" | "WORKSHOP" | "MOCK_INTERVIEW" | "COURSE" | "OTHER";
    status: "published" | "draft";
    referenceType?: string | null;
    referenceId?: string | null;
};

export type EnrollmentCohort = {
    id: string;
    name: string;
    programId: string;
    status: "open" | "closed";
};

export type ImportCandidate = {
    rowNumber: number;
    name: string;
    email: string;
    mobile: string;
    college: string;
    branch: string;
    year: string;
    rollNumber?: string;
};

export function listEnrollmentPrograms() {
    return call<Record<string, never>, EnrollmentProgram[]>("listEnrollmentPrograms", {});
}

export function ensureEnrollmentProfile() {
    return call<Record<string, never>, { profileId: string }>("ensureEnrollmentProfile", {});
}

export function listEnrollmentCohorts(programId: string) {
    return call<{ programId: string }, EnrollmentCohort[]>("listEnrollmentCohorts", { programId });
}

export function importCollegeEnrollments(data: { programId: string; cohortId: string; candidates: ImportCandidate[] }) {
    return call<typeof data, {
        importId: string;
        total: number;
        imported: number;
        invitationsQueued: number;
        results: Array<{ rowNumber: number; email: string; status: string; invitation: string; message?: string }>;
    }>("importCollegeEnrollments", data);
}

export function activateEnrollmentInvitation(token: string) {
    return call<{ token: string }, { ok: true; enrollmentId: string }>("activateEnrollmentInvitation", { token });
}

export function createCoursePaymentOrder(data: { courseRunId: string }) {
    return call<typeof data, { orderId: string; amount: number; currency: string; keyId: string; idempotent: boolean }>("createCoursePaymentOrder", data);
}

export function verifyCoursePayment(data: { razorpayOrderId: string; razorpayPaymentId: string; razorpaySignature: string }) {
    return call<typeof data, { ok: true; idempotent?: boolean }>("verifyCoursePayment", data);
}
